import CartItem from "./CartItem";
export default class Cart {
  cartId = "cart";
  items = [];

  constructor(cartName) {
    this.cartId = cartName || 'cart';
  }

  storage = {
    saveCart(object) {
      const stringified = JSON.stringify(object);
      localStorage.setItem('cart', stringified);
      return true;

    },
    getCart() {
      return JSON.parse(localStorage.getItem('cart')) || [];
    },
    clearCart() {
      localStorage.removeItem('cart');
      return true;
    }
  };

  get count() {
    return this.getItems().length;
  }

  getItems() {
    this.items = this.storage.getCart();
    return this.items;
  }

  getItem(itemIdx) {
    if (this.storage.getCart()) {
      this.items = this.storage.getCart();
    }

    if (this.items[itemIdx]) {
      return this.items[itemIdx];
    }
  }

  setItems(items) {
    this.items = items;
  }

  clearItems() {
    this.items = [];
    this.storage.clearCart();
  }

  addItem(item) {
    if (this.storage.getCart()) {
      this.items = this.storage.getCart();
    }

    if (this.items.includes(item) === false) {
      if (item instanceof CartItem) {
        this.items.push(item);
      } else {
        this.items.push(new CartItem({...item}));
      }
      this.storage.saveCart(this.items);


    } else {

      //this.updateItem(item);

    }
  }

  removeItem(itemIdx) {
    if (this.storage.getCart()) {
      this.items = this.storage.getCart();
    }

    if (this.items[itemIdx]) {
      this.items.splice(itemIdx, 1);
      this.storage.saveCart(this.items);
    }
  }
}
